/**
 * Escape a string for safe interpolation into innerHTML contexts.
 * Use for any user-facing data we render via `${}` inside template literals
 * that get passed to `innerHTML`. NOT a substitute for sanitizing user-
 * submitted HTML — only escapes the five HTML-significant characters.
 *
 * Defensive 2026-05-06: tolerate null/undefined input (returns ""). The
 * admin SPA caused a "undefined is not an object (e.replace)" crash on
 * the eSIMs page when a row had a null ownerEmail AND null ownerId after
 * a fresh DB reset. One-line guard prevents the entire page from
 * blanking on a single null cell — we render an empty string instead.
 */
export function escapeHtml(s: string | null | undefined): string {
  if (s == null) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function slugify(s: string): string {
  return s
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '') // strip combining diacriticals
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function cls(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(' ');
}
